import * as React from 'react';
function SvgPlay32(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 7.86c0-2.433 2.743-3.854 4.73-2.451l11.532 8.14c1.693 1.195 1.693 3.707 0 4.902L12.73 26.59l-.577-.817.577.817C10.743 27.994 8 26.573 8 24.141V7.86zm3.577-.817A1 1 0 0010 7.86v16.28a1 1 0 001.577.817l11.532-8.14a1 1 0 000-1.634l-11.532-8.14z"
                fill={props.color || 'currentColor'}
            />
        </svg>
    );
}
export default SvgPlay32;
